import styled from 'styled-components';

export default styled.div`
  margin-left: -20px;
  margin-bottom: 20px;
  .rs-sidebar {
    -webkit-box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12),
      0 0 10px rgba(0, 0, 0, 0.06);
  }
  .rs-sidenav {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    width: 100%;
  }
  .rs-sidenav .rs-nav-item .rs-nav-item-content > .rs-icon {
    top: 13px;
  }
  .rs-sidenav-collapse-in {
    overflow-y: auto;
  }
  .rs-header {
    padding: 0 20px;
  }
  .rs-content {
    margin: 20px 20px 0;
    background: #fff;
  }
  .nav-toggle {
    border-top: 1px solid #eee;
  }
  a.rs-btn-subtle,
  a.rs-nav-item-content,
  a.rs-dropdown-item-content {
    color: none !important;
    font-size: 13px !important;
    border-bottom: none !important;
  }
`;
